import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TRANSLATIONS } from '../i18n/translations';

export type SupportedLang = 'en' | 'es' | 'fr';

const LANG_COOKIE = 'talos_lang';
const SUPPORTED: SupportedLang[] = ['en', 'es', 'fr'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly cookies = inject(CookieService);

  readonly currentLang = signal<SupportedLang>('en');
  readonly supported = SUPPORTED;

  init(): Observable<unknown> {
    this.registerTranslations();
    const saved = this.cookies.get(LANG_COOKIE) as SupportedLang;
    const lang: SupportedLang = SUPPORTED.includes(saved) ? saved : 'en';
    this.currentLang.set(lang);
    return this.translate.use(lang);
  }

  setLanguage(lang: SupportedLang): void {
    this.translate.use(lang);
    this.cookies.set(LANG_COOKIE, lang, 365, '/');
    this.currentLang.set(lang);
  }

  private registerTranslations(): void {
    for (const lang of SUPPORTED) {
      this.translate.setTranslation(lang, TRANSLATIONS[lang], true);
    }
  }
}
